<template>
  <v-container id="city-get">
    <sala-municipio-header :payload="payload"> </sala-municipio-header>
  </v-container>
</template>

<script>
import SalaMunicipioHeader from "./SalaMunicipioHeader";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SalaMunicipioHeader,
  },
  data() {
    return {
      municipioId: this.$route.params.id,
      medalWidth: "80px",
      showMedalGrey: false,
      payload: {
        acompanhamentos: [],
        temas: [],
      },
      editReport: false,
      nomesAcompanhamentos: [],
      pontosAcompanhamentos: [],
      nomesTemas: [],
      percentuaisTemas: [],
      lineChart: {},
      lineChartOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
                max: 100,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      barChart: {},
      barChartOptions: {
        scales: {
          yAxes: [
            {
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
                max: 100,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      estado: this.$store.state.uf,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
  },
  mounted() {
    if (this.$store.state.uf === "SC") {
      this.medalWidth = "160px";
    }

    if (this.$store.state.uf !== "SC") {
      this.showMedalGrey = true;
    }

    document.getElementsByClassName("v-main__wrap")[0].style.background =
      "none";
  },
  computed: {
    ...mapGetters(["loading"]),
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
